import React from 'react';
import { connect } from 'react-redux';
import { Page } from 'signoxe/components';
import { getAsset } from 'signoxe/selectors';
import Box from '../../layout/Box';
import Button from '../../widgets/Button';
import {
    addUrlAsset, fetchUrlAssets, setPageTitle, updateUrlAsset,
} from '../../../actions';
import { getYoutubeTemplates } from 'signoxe/selectors';
import WebAssetTemplateEditor from 'signoxe/components/WebAssetTemplateEditor';
import { addWebAsset } from "signoxe/actions";
// import './styles.scss';


class YoutubePage extends React.PureComponent {
    constructor(props) {
        super(props);
        console.log('Props asset', props.asset)
        this.state = { asset: { ...props.asset } };
    }

    componentDidMount() {
        this.props.setPageTitle('Adding Data Asset');
    }

    saveEnabled() {
        return this.state.asset && this.state.asset.name && this.state.asset.content;
    }

    handleContentChange = (content) =>
        this.setState({
            asset: {
                ...this.state.asset,
                content
            }
        })

    handleNameChange = (e) =>
        this.setState({
            asset: {
                ...this.state.asset,
                name: e.currentTarget.value,
            },
        })

    handleSave = () => {
        this.props.addWebAsset(this.state.asset);
        // this.props.history.push('/assets')
        setTimeout(this.props.refresh, 700)
    };

    isNewAsset = () => this.props.match.params.id === undefined;

    saveEnabled() {
        return this.state.asset && this.state.asset.name && this.state.asset.content;
    }

    handleCancel = () => this.props.history.push('/assets');

    render() {
        console.log('Templates for Data asset', this.props.templates)
        return <div className="asset-dff">
            <input type="text" placeholder="Asset name"
                value={this.state.asset.name || ''}
                onChange={this.handleNameChange} />
            <WebAssetTemplateEditor
                content={this.state.asset.content}
                templates={this.props.templates}
                dataAsset={false}
                onChange={this.handleContentChange}
            />
            <Box direction="row" justifyContent="flex-end" className="actions button-group">
                <Button primary onClick={this.saveEnabled() ? this.handleSave : null}>Save</Button>
                <Button secondary onClick={this.handleCancel}>Cancel</Button>
            </Box>
        </div>
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        // asset: getAsset(state, parseInt(ownProps.match.params.id, 10)),
        templates: getYoutubeTemplates(state)
    }
};

const mapDispatchToProps = (dispatch, ownProps) => {
    return {
        setPageTitle: title => dispatch(setPageTitle(title))
    }
};

export default connect(mapStateToProps, {
    setPageTitle,
    addWebAsset
})(YoutubePage);



// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./src/components/AssetModal/components/Youtube.js